// @flow

import React from 'react';
import { zoomTableActionsConfig } from '../../../commons/zoomTable/zoomTableConfig';
import { RenderTableActionButtons } from '../../../commons/tableActionButton/tableActionButton';
import {
  isRelianceClientode,
  getRetailTableCellObject,
  getRetailTableFailureReasonCellObject,
  clientContractStatus,
  getFormattedDateAndTime,
  getFormattedDate,
  getFormattedTime,
  formattedStatus,
  trackPickup
} from '../../../../services/helpers';

const editImg = require('../../../../assets/images/ic_mode_edit_black_24px.svg');
const deleteImg = require('../../../../assets/images/ic_delete_black_24px.svg');
const assignImg = require('../../../../assets/images/assign.svg');
const editImg2 = require('../../../../assets/images/edit_parent.svg');
const downloadImg = require('../../../../assets/images/download-symbol.svg');

export const statusFilterList = [
  {
    val: null,
    key: 'ALL'
  },
  {
    val: 'APPROVAL_PENDING',
    key: formattedStatus('APPROVAL_PENDING')
  },
  {
    val: 'UNASSIGNED',
    key: formattedStatus('UNASSIGNED')
  },
  {
    val: 'YET_TO_REACH',
    key: formattedStatus('YET_TO_REACH')
  },
  {
    val: 'IN_PROGRESS',
    key: formattedStatus('IN_PROGRESS')
  },
  {
    val: 'COMPLETE',
    key: formattedStatus('COMPLETE')
  },
  {
    val: 'DELETED',
    key: formattedStatus('DELETED')
  },
  {
    val: 'DRAFTED',
    key: formattedStatus('DRAFTED')
  }
];

// list of pickup-types
export const recurringFilterList = [
  {
    val: 'CHILD',
    key: 'Child pickup'
  },
  {
    val: 'PARENT',
    key: 'Parent pickup'
  }
];

// map of pickup-types
export const recurringFilterMap = {
  CHILD: 'CHILD',
  PARENT: 'PARENT'
};

export const getAssignedPersonName = (row: Object) => {
  if (row.captainName) {
    return row.captainName;
  }
  if (row.bpAssigned) {
    return `${row.bpAssigned} (BP)`;
  }
  return 'Unassigned';
};

export const prqDashboardConfig = {
  columns: [
    {
      headerClassName: 'zt-custom-th flex-7',
      Header: () => (
        <div>
          <div>Creation Date</div>
          <div>Time</div>
        </div>
      ),
      sortable: false,
      className: 'zt-custom-td flex-7',
      Cell: (row: Object) =>
        getRetailTableCellObject(
          getFormattedDate(row.original.creationTime),
          getFormattedTime(row.original.creationTime)
        )
    },
    {
      headerClassName: 'zt-custom-th flex-5',
      Header: () => (
        <div>
          <div>PRQ ID &</div>
          <div>Status</div>
        </div>
      ),
      className: 'zt-custom-td flex-5',
      sortable: false,
      Cell: (row: Object) => (
        <div className="l-row a-center">
          {getRetailTableCellObject(
            row.original.id,
            formattedStatus(row.original.pickupStatus),
            row.original,
            trackPickup,
            'cn-highlight',
            formattedStatus(row.original.pickupStatus) &&
              formattedStatus(row.original.pickupStatus).toLowerCase()
          )}
          {row.original.remarks ? (
            <div title={row.original.remarks} className="icon-wrapper">
              i
            </div>
          ) : (
            ''
          )}
        </div>
      )
    },
    {
      Header: 'Client',
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      Cell: (row: Object) =>
        getRetailTableCellObject(row.original.clientName, '', row.original)
    },
    {
      headerClassName: 'flex-11 zt-custom-th',
      Header: () => (
        <div>
          <div>Requested time</div>
          <div>Actual time</div>
        </div>
      ),
      className: 'zt-custom-td flex-11',
      sortable: false,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          getFormattedDateAndTime(row.original.pickupSlotStartTime),
          getFormattedDateAndTime(row.original.actualPickupDoneTime),
          row.original,
          '',
          '',
          'grey'
        )
    },
    {
      Header: 'Captain',
      headerClassName: 'flex-11 zt-custom-th',
      sortable: false,
      className: 'no-opac zt-custom-td flex-11',
      Cell: (row: Object) =>
        getRetailTableCellObject(
          getAssignedPersonName(row.original),
          row.original.captainMobileNo || '',
          row.original,
          '',
          '',
          'grey'
        )
    },
    {
      Header: 'Contact Person',
      headerClassName: 'flex-9 zt-custom-th',
      sortable: false,
      className: 'zt-custom-td flex-9',
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original.contactPerson,
          row.original.contactNumber,
          row.original,
          '',
          '',
          'grey'
        )
    },
    {
      Header: 'Location',
      headerClassName: 'flex-6 zt-custom-th',
      sortable: false,
      className: 'zt-custom-td flex-6',
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original.locationName,
          row.original.locationCode,
          row.original,
          '',
          '',
          'grey'
        )
    },
    {
      Header: 'Pickup Address',
      headerClassName: 'flex-12 zt-custom-th',
      sortable: false,
      className: 'zt-custom-td flex-12',
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original.consignorName,
          row.original.detailedAddress,
          row.original,
          null,
          '',
          'grey'
        )
    },
    {
      headerClassName: 'flex-7 zt-custom-th',
      Header: () => (
        <div>
          <div>Weight</div>
          <div>Packages</div>
        </div>
      ),
      className: 'zt-custom-td flex-7',
      sortable: false,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original.weightRange,
          row.original.numberOfBoxes,
          row.original,
          null,
          null,
          'grey'
        )
    },
    {
      headerClassName: 'flex-8 zt-custom-th',
      Header: 'Failure Reason (Count)',
      className: 'zt-custom-td flex-7',
      sortable: false,
      Cell: (row: Object) =>
        getRetailTableFailureReasonCellObject(row.original.failureReasons)
    },
    {
      headerClassName: 'flex-7 zt-custom-th',
      Header: 'Client Contract Status',
      className: 'zt-custom-td flex-7',
      sortable: false,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original.clientContractStatus,
          null,
          null,
          null,
          row.original.clientContractStatus === clientContractStatus.ACTIVE
            ? 'created'
            : row.original.clientContractStatus === clientContractStatus.EXPIRED
            ? 'deleted'
            : 'grey'
        )
    },
    {
      Header: 'Remarks',
      headerClassName: 'flex-8 zt-custom-th',
      sortable: false,
      accessor: 'failureReason',
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original.failureReason,
          null,
          row.original
        ),
      className: 'zt-custom-td flex-8'
    },
    {
      Header: '',
      headerClassName: 'flex-10 zt-custom-th',
      className: 'flex-10 ',
      sortable: false,
      Cell: obj => (
        <RenderTableActionButtons
          rowData={obj.original || {}}
          buttonConfig={zoomTableActionsConfig.PRQ_DASHBOARD.buttons}
        />
      )
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: 'No pickups found',
  minRows: 0,
  pageSizeOptions: [7, 10, 15, 25, 50, 100],
  style: { maxHeight: 'calc(100vh - 18rem)' }
};

export const prqDashboardTableActionConfig = {
  buttons: [
    {
      // configuration of edit parent button on PRQ Dashboard
      label: 'Edit Parent',
      iconOnly: true,
      iconRef: editImg2,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.PRQ_DASHBOARD.actions &&
          zoomTableActionsConfig.PRQ_DASHBOARD.actions.editParentPickup
        ) {
          zoomTableActionsConfig.PRQ_DASHBOARD.actions.editParentPickup(
            rowData
          );
        }
      },
      hide: rowData =>
        !zoomTableActionsConfig.PRQ_DASHBOARD.actions ||
        !zoomTableActionsConfig.PRQ_DASHBOARD.actions.editParentPickup ||
        rowData.isRecurring != 1 ||
        (rowData.isRecurring === 1 && rowData.oldPrqId === null),
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '4rem',
        height: '4rem',
        margin: '0'
      }
    },
    {
      label: 'Assign',
      iconOnly: true,
      iconRef: assignImg,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.PRQ_DASHBOARD.actions &&
          zoomTableActionsConfig.PRQ_DASHBOARD.actions.assignPickup
        ) {
          zoomTableActionsConfig.PRQ_DASHBOARD.actions.assignPickup(rowData);
        }
      },
      hide: rowData =>
        !zoomTableActionsConfig.PRQ_DASHBOARD.actions ||
        !zoomTableActionsConfig.PRQ_DASHBOARD.actions.assignPickup ||
        (zoomTableActionsConfig.PRQ_DASHBOARD.actions.hideAssignButton &&
          zoomTableActionsConfig.PRQ_DASHBOARD.actions.hideAssignButton(
            rowData
          )),
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '4rem',
        height: '4rem',
        margin: '0'
      }
    },
    {
      label: 'Edit',
      iconOnly: true,
      iconRef: editImg,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.PRQ_DASHBOARD.actions &&
          zoomTableActionsConfig.PRQ_DASHBOARD.actions.editPickup
        ) {
          zoomTableActionsConfig.PRQ_DASHBOARD.actions.editPickup(rowData);
        }
      },
      hide: rowData =>
        !zoomTableActionsConfig.PRQ_DASHBOARD.actions ||
        !zoomTableActionsConfig.PRQ_DASHBOARD.actions.editPickup ||
        (!(rowData.isRecurring === 1 && rowData.oldPrqId === null) &&
          (rowData.pickupStatus === 'DELETED' ||
            rowData.pickupStatus === 'COMPLETE' ||
            rowData.pickupStatus === 'REACHED_AT_CLIENT_WAREHOUSE')),
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '4rem',
        height: '4rem',
        margin: '0'
      }
    },
    {
      label: 'Delete',
      iconOnly: true,
      iconRef: deleteImg,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.PRQ_DASHBOARD.actions &&
          zoomTableActionsConfig.PRQ_DASHBOARD.actions.deletePickup
        ) {
          zoomTableActionsConfig.PRQ_DASHBOARD.actions.deletePickup(rowData);
        }
      },
      hide: rowData =>
        !zoomTableActionsConfig.PRQ_DASHBOARD.actions ||
        !zoomTableActionsConfig.PRQ_DASHBOARD.actions.deletePickup ||
        rowData.pickupStatus === 'DELETED' ||
        rowData.pickupStatus === 'COMPLETE' ||
        (typeof rowData.cnotesOfPickup === 'string' && rowData.cnotesOfPickup),
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '4rem',
        height: '4rem',
        margin: '0'
      }
    },
    {
      label: 'Download',
      iconOnly: true,
      iconRef: downloadImg,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.PRQ_DASHBOARD.actions &&
          zoomTableActionsConfig.PRQ_DASHBOARD.actions.downloadPickup
        ) {
          zoomTableActionsConfig.PRQ_DASHBOARD.actions.downloadPickup(rowData);
        }
      },
      hide: rowData =>
        !zoomTableActionsConfig.PRQ_DASHBOARD.actions ||
        !zoomTableActionsConfig.PRQ_DASHBOARD.actions.downloadPickup ||
        rowData.pickupStatus !== 'COMPLETE',
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '4rem',
        height: '4rem',
        margin: '0'
      }
    }
  ]
};

export const sortDataByReliancePickups = (userProfile, dashboardData) => {
  return dashboardData.sort((e1, e2) => {
    const isRelianceClientCodeElement1 = isRelianceClientode(
      userProfile,
      e1.clientCode
    );
    const isRelianceClientCodeElement2 = isRelianceClientode(
      userProfile,
      e2.clientCode
    );

    if (isRelianceClientCodeElement1 && isRelianceClientCodeElement2) {
      return 0;
    }
    if (isRelianceClientCodeElement1) {
      return -1;
    }
    if (isRelianceClientCodeElement2) {
      return 1;
    }
    return 0;
  });
};
